import { dark } from "./dark";
import { defaultPalette } from "./default";
import { light } from "./light";

export const palettes = { light, dark, default: defaultPalette };
